import { createAsyncThunk } from '@reduxjs/toolkit';

import { SHOPIFY_CHANNEL_TYPE } from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const getSalesChannelMapping = createAsyncThunk(
  'salesChannels/getSalesChannelMapping',
  async ({ salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.getSalesChannelMapping({
        type: SHOPIFY_CHANNEL_TYPE,
        salesChannelId,
      });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Get sales channel mapping failed'),
        { error, salesChannelId },
        ['ConnectShopifyChGetMappingFailed', { salesChannelId: salesChannelId ? String(salesChannelId) : '' }],
      );
      throw error;
    }
  },
);
